module.exports = __webpack_public_path__ + "assets/img/home_1.e59b777e.svg";